import React from "react";
import { useNavigate } from "react-router-dom";

export default function SucessfullySubmited({ type, handleSucessfulyfalse }) {
  const navigate = useNavigate();
  return (
    <div className="ContainerSubmitedSucess">
      <div className="SubContainerSubmitedSucess d-flex justify-content-center flex-column align-items-center">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/HwImg/sucessIcon.png" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
          {type == "SA" ? "You Have successfully submitted the Self Assessment" : "You Have successfully submitted the homework"}
        </div>
        {/* {
          type == "SA" ? null : 
          <div className="d-flex justify-content-center align-items-center mt-2 sucessMsg2">
            Once teacher evaluates, you will be notified
          </div>
        } */}

        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="okayBtnsucess"
            onClick={() => {
              if (type == "SA") {
                navigate('/SelfAssessment');
              } else {
                navigate('/Homework');
              }
              handleSucessfulyfalse();
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
